import React from "react";

import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import PrismaCloudComputeConfligListing from "./PrismaCloudComputeConfigListing";
import PrismaCloudComputeCredentialsForm from "./PrismaCloudComputeCredentialsForm";

const PrismaCloudComputePullAndPushView = (props) => (
  <GenericPullAndPushToolView
    {...props}
    PullCredentialForm={PrismaCloudComputeCredentialsForm}
    PullConfigListingView={PrismaCloudComputeConfligListing}
  />
);

export default PrismaCloudComputePullAndPushView;
